import { endpoints } from "./endpoints";
import { authedGet } from "./http";

export const fetchWindRisk = async (projectId) => {
  try {
    const { data } = await authedGet(endpoints.apps.windRisk(projectId));
    if (Array.isArray(data)) return data;
    if (data && typeof data === "object") return Object.values(data);
    return [];
  } catch {
    return [];
  }
};
